import { useEffect, useState } from 'react'
import { Button, Form } from 'react-bootstrap'
import { toast } from 'react-toastify'
import { generateRandomCode } from '../home/logic'

export function NotificationTest() {
    const [codeInput, setCodeInput] = useState('')
    const [code, setCode] = useState('')

    useEffect(() => {
        setCode(generateRandomCode(3))
    }, [])

    const handleConfirmCode = () => {
        if (codeInput === code) {
            toast.success('Código correcto')
            window.close()
        } else {
            toast.error('Código incorrecto')
        }
    }
    return (
        <div className='py-3 px-5 text-center'>
            <div className='fs-3 mb-3'>
                <span style={{ borderBottom: '2px solid #000' }}>Configuración completada</span>
            </div>

            <p className='text-center fs-5'>
                Ingrese el código de prueba: <span className='fw-medium'>{code}</span>
            </p>
            <div className='mb-3 d-flex gap-3'>
                <Form.Control
                    value={codeInput}
                    onChange={(e) => setCodeInput(e.target.value.toUpperCase())}
                    onKeyUp={(e) => {
                        e.key === 'Enter' && handleConfirmCode()
                    }}
                    placeholder='Código'
                />
                <Button variant='blue' onClick={handleConfirmCode}>
                    Confirmar
                </Button>
            </div>
            <Button variant='danger' onClick={() => window.close()}>
                Cerrar ventana
            </Button>
        </div>
    )
}
